import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e915f54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rich-menu-edit-wrapper main-content-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "リッチメニュー", -1))
const _hoisted_3 = { class: "rich-menu-edit-page" }
const _hoisted_4 = {
  key: 0,
  class: "row mt-3 message-success"
}
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "input-group flex flex-column gap-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "title",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("タイトル"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title input-group inline-block" }, [
  /*#__PURE__*/_createTextVNode("コンテンツ設定"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_11 = { class: "input-group flex flex-wrap gap-3 radio-buttom-custom" }
const _hoisted_12 = { class: "flex align-items-center" }
const _hoisted_13 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_14 = {
  key: 1,
  class: "icon-lms icon-lms_rad radio-icon"
}
const _hoisted_15 = { class: "flex align-items-center" }
const _hoisted_16 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_17 = {
  key: 1,
  class: "icon-lms icon-lms_rad radio-icon"
}
const _hoisted_18 = {
  key: 0,
  class: "input-group flex flex-wrap gap-3 grid"
}
const _hoisted_19 = { class: "lg:col-3 sm:col-12" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "title" }, "タブの数")
], -1))
const _hoisted_21 = { class: "field" }
const _hoisted_22 = { class: "lg:col-3 sm:col-12" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "tab-height",
    class: "title"
  }, "タブの高さ")
], -1))
const _hoisted_24 = { class: "field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { class: "pl-4 tab-title" }
const _hoisted_27 = { class: "px-4 py-1" }
const _hoisted_28 = { class: "grid" }
const _hoisted_29 = { class: "left-area lg:ml-2" }
const _hoisted_30 = { class: "button-group flex justify-content-start -ml-2" }
const _hoisted_31 = ["onChange"]
const _hoisted_32 = { class: "right-area lg:col-7 md:col-12 sm:col-12" }
const _hoisted_33 = { class: "icon-with-text flex align-items-center mt-2 mb-4" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-circle-down" }, null, -1))
const _hoisted_35 = { class: "font-bold ml-2" }
const _hoisted_36 = { class: "field flex flex-column align-items-start justify-content-between mt-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "white-space-nowrap" }, [
  /*#__PURE__*/_createTextVNode(" アクションタイプ "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text pl-2" }, " 必須 ")
], -1))
const _hoisted_38 = { class: "w-4" }
const _hoisted_39 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_40 = { class: "field flex flex-column align-items-start justify-content-between" }
const _hoisted_41 = ["for"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-text pl-2" }, " 必須 ", -1))
const _hoisted_43 = { class: "w-100" }
const _hoisted_44 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_45 = {
  key: 1,
  class: "p-error text-sm"
}
const _hoisted_46 = { class: "w-full flex justify-content-end align-items-end" }
const _hoisted_47 = { class: "dialog-wrapper" }
const _hoisted_48 = { class: "" }
const _hoisted_49 = { class: "grid grid-nogutter menu-template-wrapper" }
const _hoisted_50 = ["data-id"]

import axios from "axios";
import { onBeforeMount, ref, inject, computed } from "vue";
import RadioButton from "primevue/radiobutton";
import InputNumber from "primevue/inputnumber";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import RouterUtils from "@/common/utils/router.util";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";
import RouterConstants from "@/clinic/constants/router.constants";
import { RichMenuServices, RichMenuTemplateServices } from "../services";
import { ILinesMenuTemplate, IRichMenuDetail } from "../typings";
import { useCookies } from "@vueuse/integrations/useCookies";
import InlineMessage from "primevue/inlinemessage";
import { get, set } from "@vueuse/core";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'RichMenuEdit',
  setup(__props) {

const toast = useToast();
const route = useRoute();

const idUrl = computed((): number => {
  const { params } = route;
  const { id } = params;
  return id as unknown as number;
});

const clinicId = ref(0);
const validateErrors = ref(false);
const richmenuGroup = ref({
  title: "",
  group_type: "",
  tab_height: 10,
  number_of_tabs: 2,
});
const currentTab = ref(0);
const visible = ref(false);
const previewBoxError = ref([]);
const showURLValidationError = ref(false);
const numberOfTabs = ref([
  { name: "2", value: 2 },
  { name: "3", value: 3 },
  { name: "4", value: 4 },
  { name: "5", value: 5 },
  { name: "6", value: 6 },
]);
const defaultMenu = ref({
  image: "",
  template: {
    id: 1,
    items: { A: { height: "100%", width: "100%", position: 1 } },
  },
  items: [
    {
      item_type: "uri",
      content: "",
      position_name: "A",
    },
  ],
});
const richmenus = ref();
const richmenuTemplates = ref();
const previewTemplateElements = ref([]);
const menuItemTypes = ref([{ name: "リンク", code: "uri" }]);
const loading = ref(false);
const inputsUploadImage = ref([]);
let isSuccess = ref(false);

const isSelectedTemplate = templateId => {
  return richmenus.value[currentTab.value]?.template?.id == templateId;
};

const chooseTemplate = () => {
  document.querySelectorAll(".menu-template-wrapper .template-wrapper").forEach(element => {
    element.classList.remove("selected");
  });
  event.currentTarget.classList.add("selected");
};

const handleSelectTemplate = () => {
  document.querySelectorAll(".menu-template-wrapper .template-wrapper").forEach(element => {
    if (element.classList.contains("selected")) {
      richmenus.value[currentTab.value].template = richmenuTemplates.value.find(
        template => template.id == element.dataset.id
      );

      richmenus.value[currentTab.value].items = Object.keys(richmenus.value[currentTab.value].template.items).map(
        blockName => {
          return {
            item_type: "uri",
            content: "",
            position_name: blockName,
          };
        }
      );
    }
  });
  visible.value = false;
};

const validateURL = (value: string) => {
  set(showURLValidationError, false);

  if (value?.trim() === "" || !value) return;
  const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
  const isURLValid = urlPattern.test(value);
  const result = !isURLValid && get(value) !== "";

  set(showURLValidationError, result);
  return result;
};

const validatePresent = value => {
  return validateErrors.value && (value == "" || value == null);
};

const blockStyle = block => {
  return {
    float: "left",
    height: block.height,
    width: block.width,
  };
};

const backToList = () => RouterUtils.goTo(RouterConstants.RICH_MENU_ROUTER_NAME);

const updateRichMenu = () => {
  loading.value = true;

  if (validates()) {
    loading.value = false;
    return;
  }

  const data = richmenus.value.map(menu => {
    return {
      template_id: menu.template.id,
      items: menu.items,
    };
  });

  var formData = new FormData();
  formData.append("title", richmenuGroup.value.title);
  formData.append("group_type", richmenuGroup.value.group_type);
  formData.append("tab_height", richmenuGroup.value.tab_height);
  formData.append("number_of_tabs", richmenuGroup.value.number_of_tabs);
  richmenus.value.forEach(menu => {
    formData.append("images[]", menu.image.file || menu.id);
  });
  formData.append("menus", JSON.stringify(data));

  const { get: getCookie } = useCookies();
  const token = getCookie("access_token");
  const urlRequest = `${ApiRouterConstants.API_RICH_MENUS}/${richmenuGroup.value.id}?clinic_id=${get(clinicId.value)}`;
  axios
    .patch(urlRequest, formData, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + token,
      },
    })
    .then(() => {
      RouterUtils.goTo(RouterConstants.RICH_MENU_ROUTER_NAME);
    })
    .catch(error => {
      loading.value = false;
      toast.add({
        severity: "error",
        detail: "何かが間違っています。後でもう一度試してください",
        life: 3000,
      });
    });
};

const openSelectFile = n => {
  inputsUploadImage.value[n].click();
};

const showMessageErrorImage = (no: number, message: string) => {
  if (previewBoxError.value[no]) {
    set(validateErrors, true);
    previewBoxError.value[no]?.classList.remove("hidden");
    previewBoxError.value[no].innerHTML = message;
  }
};

const hiddenMessageErrorImage = (no: number) => {
  if (previewBoxError.value[no]) {
    set(validateErrors, false);
    previewBoxError.value[no].classList.add("hidden");
    previewBoxError.value[no].innerHTML = "";
  }
};

const getExtFilename = filename => {
  return filename.split(".").pop();
};

const validateImage = n => {
  let reader = new FileReader();
  if (inputsUploadImage.value[n]?.files[0]) {
    const whiteListExt = ["png", "jpeg"];
    reader.readAsDataURL(inputsUploadImage.value[n].files[0]);
    reader.onload = evt => {
      let img = new Image();
      img.onload = () => {
        if (!whiteListExt.includes(getExtFilename(inputsUploadImage.value[n].files[0].name))) {
          toast.add({
            severity: "error",
            detail: "Only png and jpeg files are allowed",
            life: 3000,
          });
        } else if (inputsUploadImage.value[n].files[0].size > 1000000) {
          toast.add({
            severity: "error",
            detail: "最大サイズファイル:1MB",
            life: 3000,
          });
        } else if (img.width < 800 || img.width > 2500) {
          toast.add({
            severity: "error",
            detail: "画像幅 (ピクセル):800から2500まで",
            life: 3000,
          });
        } else if (img.height < 250) {
          toast.add({
            severity: "error",
            detail: "画像高さ(ピクセル):250以上",
            life: 3000,
          });
        } else if (img.width / img.height < 1.45) {
          toast.add({
            severity: "error",
            detail: "画像アスペクト比(高さ／幅):1.45以上",
            life: 3000,
          });
        } else {
          richmenus.value[n].image = {
            file: inputsUploadImage.value[n].files[0],
          };
          previewTemplateElements.value[n].style.background = `url(${evt.target.result})`;
          previewTemplateElements.value[n].style.backgroundPosition = "center";
          previewTemplateElements.value[n].style.backgroundRepeat = "no-repeat";
          previewTemplateElements.value[n].style.backgroundSize = "100% 100%";
          previewTemplateElements.value[n].style.height = `${(334 * img.height) / img.width}px`;
          hiddenMessageErrorImage(n);
        }
      };
      img.src = evt.target.result;
    };
  }
};

const validates = () => {
  validateErrors.value = false;

  if (richmenuGroup.value.title == "") {
    validateErrors.value = true;
  }

  if (get(showURLValidationError)) {
    set(validateErrors, true);
  }

  get(richmenus).forEach((menu, index) => {
    menu.items.forEach(item => {
      if (item.content == "" || item.item_type == "" || item.image == "") {
        validateErrors.value = true;
      }
    });

    if (!menu?.image?.file && !menu?.id) {
      showMessageErrorImage(index, "このフィールドは必須です。");
    }
  });

  return validateErrors.value;
};

const onChangeGroupType = () => {
  if (richmenuGroup.value.group_type == "single_menu") {
    richmenus.value = [richmenus.value[0]];
    richmenuGroup.value.number_of_tabs = 1;
  } else {
    const dataDefaultMenu = JSON.parse(JSON.stringify(get(defaultMenu)));
    richmenus.value.push({ ...dataDefaultMenu });
    richmenuGroup.value.number_of_tabs = 2;
  }
};

const onChangeNumberOfTabs = () => {
  if (richmenuGroup.value.number_of_tabs > richmenus.value.length) {
    const totalNewMenu = richmenuGroup.value.number_of_tabs - richmenus.value.length;
    for (let i = 0; i < totalNewMenu; i++) {
      const dataDefaultMenu = JSON.parse(JSON.stringify(get(defaultMenu)));
      richmenus.value.push({ ...dataDefaultMenu });
    }
  } else {
    richmenus.value = richmenus.value.slice(0, richmenuGroup.value.number_of_tabs);
  }
};

const openTemplatePopup = n => {
  visible.value = true;
  currentTab.value = n;
};

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
  const params = {
    id: get(idUrl),
    clinic_id: get(clinicId.value),
  };
  const { data } = (await RichMenuServices.getRichMenu(params)) as unknown as IRichMenuDetail[];
  richmenus.value = data.value;

  const [richMenu] = data.value;
  richmenuGroup.value = richMenu.group;

  const { data: templates } =
    (await RichMenuTemplateServices.getRichMenuTemplates()) as unknown as ILinesMenuTemplate[];
  richmenuTemplates.value = templates.value;

  previewTemplateElements.value.forEach((element, index) => {
    let img = new Image();

    img.onload = () => {
      if (richmenus.value[index]?.image?.url) {
        element.style.background = `url(${richmenus.value[index].image.url})`;
        element.style.backgroundPosition = "center";
        element.style.backgroundRepeat = "no-repeat";
        element.style.backgroundSize = "100% 100%";
        element.style.height = `${(300 * img.height) / img.width}px`;
      }
    };

    img.src = richmenus.value[index].image.url;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_dropdown = _resolveComponent("dropdown")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_unref(isSuccess))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(InlineMessage), {
              class: "w-100",
              severity: "success",
              icon: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存が完了しました")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InputText, {
              id: "menu-title",
              class: "p-float-label flex border-round-md border-200 w-9",
              placeholder: "タイトルテキスト",
              modelValue: richmenuGroup.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((richmenuGroup.value.title) = $event))
            }, null, 8, ["modelValue"]),
            (validatePresent(richmenuGroup.value.title))
              ? (_openBlock(), _createElementBlock("small", _hoisted_9, "このフィールドは必須です。"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(RadioButton), {
                modelValue: richmenuGroup.value.group_type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((richmenuGroup.value.group_type) = $event)),
                inputId: "single-menu",
                name: "menuType",
                value: "single_menu",
                onChange: onChangeGroupType
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", {
                for: "single-menu",
                class: _normalizeClass(["flex algin-items-center", {
                  'text-orange': richmenuGroup.value.group_type === 'single_menu',
                }])
              }, [
                (richmenuGroup.value.group_type === 'single_menu')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14)),
                _createTextVNode(" 単一タブ ")
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_unref(RadioButton), {
                modelValue: richmenuGroup.value.group_type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((richmenuGroup.value.group_type) = $event)),
                inputId: "tabs-menu",
                name: "menuType",
                value: "tab_menu",
                onChange: onChangeGroupType
              }, null, 8, ["modelValue"]),
              _createElementVNode("label", {
                for: "tabs-menu",
                class: _normalizeClass(["flex algin-items-center", {
                  'text-orange': richmenuGroup.value.group_type === 'tab_menu',
                }])
              }, [
                (richmenuGroup.value.group_type === 'tab_menu')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                  : (_openBlock(), _createElementBlock("span", _hoisted_17)),
                _createTextVNode(" 複数タブ ")
              ], 2)
            ])
          ]),
          (richmenuGroup.value.group_type == 'tab_menu')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Dropdown, {
                      modelValue: richmenuGroup.value.number_of_tabs,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((richmenuGroup.value.number_of_tabs) = $event)),
                      options: numberOfTabs.value,
                      optionLabel: "name",
                      optionValue: "value",
                      class: "w-full md:w-14rem p-inputtext",
                      onChange: onChangeNumberOfTabs
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_unref(InputNumber), {
                      modelValue: richmenuGroup.value.tab_height,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((richmenuGroup.value.tab_height) = $event)),
                      inputId: "tab-height",
                      min: 10,
                      max: 50,
                      showButtons: "",
                      buttonLayout: "horizontal",
                      suffix: "%",
                      decrementButtonClass: "p-button-danger",
                      incrementButtonClass: "p-button-success",
                      incrementButtonIcon: "pi pi-plus",
                      decrementButtonIcon: "pi pi-minus",
                      allowEmpty: false,
                      class: "w-full md:w-14rem"
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_25,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(richmenus.value, (menu, index) => {
            return (_openBlock(), _createBlock(_component_Card, {
              key: index,
              class: "tab-card"
            }, {
              title: _withCtx(() => [
                _createElementVNode("span", _hoisted_26, "タブ" + _toDisplayString(index + 1), 1)
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", {
                        class: "template-preview-wrapper mb-4",
                        ref_for: true,
                        ref: 
                        el => {
                          previewTemplateElements.value[index] = el;
                        }
                      
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.template.items, (block, blockName) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "template-block flex align-items-center justify-content-center flex-wrap",
                            key: block.position,
                            style: _normalizeStyle(blockStyle(block))
                          }, _toDisplayString(blockName), 5))
                        }), 128)),
                        _createElementVNode("small", {
                          class: "p-error text-sm hidden",
                          ref_for: true,
                          ref: 
                          el => {
                            previewBoxError.value[index] = el;
                          }
                        
                        }, null, 512)
                      ], 512),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_Button, {
                          class: "p-button border-round select-template-btn mr-3",
                          onClick: ($event: any) => (openTemplatePopup(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("テンプレートを選択")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_Button, {
                          class: "p-button border-round select-template-image-btn",
                          onClick: ($event: any) => (openSelectFile(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 画像アップロード ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/png, image/jpeg",
                          class: "hidden",
                          ref_for: true,
                          ref: 
                          el => {
                            inputsUploadImage.value[index] = el;
                          }
                        ,
                          onChange: ($event: any) => (validateImage(index))
                        }, null, 40, _hoisted_31)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.template.items, (block, blockName, k) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "menu-item-wrapper ml-4 p-4 mb-4 pl-0",
                          key: blockName
                        }, [
                          _createElementVNode("h5", _hoisted_33, [
                            _hoisted_34,
                            _createElementVNode("span", _hoisted_35, _toDisplayString(blockName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_dropdown, {
                                class: "w-full text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none focus:border-primary line-height-1",
                                options: menuItemTypes.value,
                                optionLabel: "name",
                                optionValue: "code",
                                modelValue: menu.items[k].item_type,
                                "onUpdate:modelValue": ($event: any) => ((menu.items[k].item_type) = $event)
                              }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                              (validatePresent(menu.items[k].item_type))
                                ? (_openBlock(), _createElementBlock("small", _hoisted_39, "このフィールドは必須です。"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("label", {
                              for: `item-content-${block.id}`
                            }, [
                              _createTextVNode("リンクURL"),
                              _hoisted_42
                            ], 8, _hoisted_41),
                            _createElementVNode("div", _hoisted_43, [
                              _createVNode(_component_InputText, {
                                class: "text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full",
                                modelValue: menu.items[k].content,
                                "onUpdate:modelValue": ($event: any) => ((menu.items[k].content) = $event),
                                placeholder: "URLテキスト"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (validatePresent(menu.items[k].content))
                                ? (_openBlock(), _createElementBlock("small", _hoisted_44, "このフィールドは必須です。"))
                                : (validateURL(menu.items[k].content))
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_45, " 間違った形式。 "))
                                  : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_Button, {
              label: "キャンセル",
              class: "p-button-light btn-cancel mr-3",
              onClick: backToList
            }),
            _createVNode(_component_Button, {
              class: "btn-new mt-3 border-transparent flex justify-content-center",
              onClick: updateRichMenu,
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(" リッチメニューを保存 ")
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _createVNode(_component_Dialog, {
          class: "dialog-choose-templates",
          visible: visible.value,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
          modal: "",
          header: "テンプレートを選択",
          style: { width: '803px' }
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "キャンセル",
              class: "p-button-light mr-3",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (visible.value = false))
            }),
            _createVNode(_component_Button, {
              label: "登録",
              class: "mr-2",
              onClick: handleSelectTemplate
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_49, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(richmenuTemplates.value, (template) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-3",
                  key: template.id
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["template-wrapper m-2", { selected: isSelectedTemplate(template.id) }]),
                    onClick: chooseTemplate,
                    "data-id": template.id
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.items, (item, blockName) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "template-block flex align-items-center justify-content-center flex-wrap",
                        key: item.position,
                        style: _normalizeStyle(blockStyle(item))
                      }, _toDisplayString(blockName), 5))
                    }), 128))
                  ], 10, _hoisted_50)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ]))
}
}

})